export default __webpack_public_path__ + "static/media/arep.64e30331.svg";